var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    class: { inputText: true, "non-editable": !_vm.isEditable },
    attrs: { contenteditable: true },
    on: {
      keydown: _vm.handleKeydown,
      paste: _vm.handlePaste,
      compositionstart: _vm.divCompositionstart,
      compositionend: _vm.divCompositionend,
      blur: _vm.handleBlur,
      focus: _vm.cusFocus,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }